module.exports = __webpack_public_path__ + "static/media/checkmark_icon.3a7a5811.svg";